import { toast } from 'react-toastify'

import { areAdminNewOrderNotificationsEnabled } from './adminNewOrderNotificationsPreference'
import {
  formatOrderPaymentNotificationText,
  OrderPaymentStatusPayload,
} from './formatOrderPaymentNotificationText'
import { shouldNotifyNewOrder } from './shouldNotifyNewOrder'
import { showPaymentStatusNotification } from './showPaymentStatusNotification'

/**
 * Параметры обработки события оплаты от платёжной системы.
 */
export type ProcessIncomingPaymentStatusParams = {
  payload: OrderPaymentStatusPayload
  filterPizzeriaId: number | null
  onNavigateHome?: () => void
  onRefetchHome?: () => void
}

/**
 * Тост + Browser Notification о результате оплаты (только при включённых уведомлениях).
 * @param params — payload сокета и фильтр пиццерии
 * @returns true, если уведомление показано
 */
export const processIncomingPaymentStatus = (
  params: ProcessIncomingPaymentStatusParams
): boolean => {
  const { payload, filterPizzeriaId, onNavigateHome, onRefetchHome } = params

  if (!areAdminNewOrderNotificationsEnabled()) {
    return false
  }

  if (
    !shouldNotifyNewOrder({
      filterPizzeriaId,
      orderPizzeriaId: payload?.pizzeria_id,
    })
  ) {
    return false
  }

  const { title, body } = formatOrderPaymentNotificationText(payload)
  const fullMessage = body

  if (payload.outcome === 'succeeded') {
    toast.success(fullMessage, {
      autoClose: 8000,
      icon: '✅',
    })
  } else {
    toast.error(fullMessage, {
      autoClose: 10000,
      icon: '❌',
    })
  }

  showPaymentStatusNotification({
    title,
    body,
    orderId: payload.id,
    outcome: payload.outcome,
    onClick: onNavigateHome,
  })

  onRefetchHome?.()
  return true
}
